var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsAutoWalletTopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 121,
    viewBox: "0 0 140 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icons_auto_wallet_topup"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 121
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_auto_wallet_topup",
    clipPath: "url(#clip-icons_auto_wallet_topup)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Wallet_Grey_Icon",
    "data-name": "Icons_Wallet_Grey Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M258.833,325.273V308.205a8.741,8.741,0,0,1,8.742-8.673h22.15V280.974a6.779,6.779,0,0,0-6.779-6.735H182.439a13.137,13.137,0,0,1-4.168-.679v83.7a2.018,2.018,0,0,0,2.017,2.008H282.946a6.773,6.773,0,0,0,6.792-6.735V333.946H267.574A8.74,8.74,0,0,1,258.833,325.273Z",
    transform: "translate(-169.488 -247.643)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M182.45,222.16h89v-6.286a2.005,2.005,0,0,0-2-1.981h-87a4.134,4.134,0,0,0,0,8.268Z",
    transform: "translate(-169.523 -205.052)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M501.745,417.019l32.75-.128V399.951l-32.885.127Z",
    transform: "translate(-403.333 -339.674)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M277.478,233.139h-2.243V214.471a15.674,15.674,0,0,0-15.645-15.641H257.6v-6.29a10.9,10.9,0,0,0-10.89-10.886H159.244a13.075,13.075,0,0,0-13,12.836v96.74a10.9,10.9,0,0,0,10.89,10.887h102.5a15.672,15.672,0,0,0,15.631-15.628V267.772h2.249a8.768,8.768,0,0,0,8.728-8.731V241.864A8.809,8.809,0,0,0,277.478,233.139ZM159.244,190.546h87.517a2.017,2.017,0,0,1,2.014,1.993v6.324H159.244a4.159,4.159,0,0,1,0-8.317Zm107.128,95.9a6.788,6.788,0,0,1-6.782,6.775H157.09a2.023,2.023,0,0,1-2.014-2.02v-84.2a13.029,13.029,0,0,0,4.162.684H259.591a6.794,6.794,0,0,1,6.768,6.775v18.669H244.243a8.76,8.76,0,0,0-8.728,8.725v17.17a8.76,8.76,0,0,0,8.728,8.725h22.13v18.7Zm10.978-27.535-32.946.128L244.27,242l33.081-.128v17.042Z",
    transform: "translate(-146.24 -181.653)",
    fill: "#6cb33f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M32.673,52.915c-6.457-.11-5.971-8.117,0-7.9,1.254.048,1.906,0,1.906,0A17.742,17.742,0,0,0,47.724,39.6a17.744,17.744,0,0,0,5.41-13.145,17.743,17.743,0,0,0-5.41-13.143A17.737,17.737,0,0,0,34.58,7.9a18.036,18.036,0,0,0-13.164,5.257,16.943,16.943,0,0,0-5.089,9.412l3.1-3.1a1.905,1.905,0,0,1,2.7,0l2.7,2.7a1.905,1.905,0,0,1,0,2.7L16.735,32.95l-2.7,2.7a1.908,1.908,0,0,1-2.7,0L.559,24.862a1.905,1.905,0,0,1,0-2.7l2.7-2.7a1.905,1.905,0,0,1,2.7,0L8.48,22a25.407,25.407,0,0,1,1.706-5.874A26.389,26.389,0,0,1,24.249,2.062a26.91,26.91,0,0,1,20.663,0A26.389,26.389,0,0,1,58.975,16.127a26.116,26.116,0,0,1,2.064,10.331A26.13,26.13,0,0,1,58.975,36.79,26.378,26.378,0,0,1,44.912,50.853,26.123,26.123,0,0,1,34.58,52.915s-.257.018-.822.018C33.475,52.933,33.116,52.928,32.673,52.915Z",
    transform: "translate(21.194 41.001)",
    fill: "#6cb33f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAutoWalletTopup);
export default __webpack_public_path__ + "static/media/icons_auto_wallet_topup.ac4021f123454d454f48e934d0e6f3bc.svg";
export { ForwardRef as ReactComponent };